import { notification } from 'antd';
import { deleteBuyerPointFx, fetchBuyerPointsFx } from '../store/points.store';

export const deleteBuyerPoint = async (id: number) => {
  try {
    const res = await deleteBuyerPointFx(id);
    notification.success({ message: 'Пункт приема зерна успешно удален' });
    await fetchBuyerPointsFx();
    return res;
  } catch (err: any) {
    const res = err.body && await err.json();
    return notification.error({
      message: res?.error ? res.error : 'Непредвиденная ошибка. Попробуйте позже',
    });
  }
};
